export default __webpack_public_path__ + "static/media/nccColored.5c2f2057.png";